let uniqueId = 1;

export default (array = []) => {
  array.forEach((element) => {
    element.id = element.id || uniqueId++;
  });
};
